import { TOUR_REMINDER_URL } from "@website/accommodation-ui/constant/addresses";
import { UpdateReminderBody } from "@website/accommodation-ui/tour-reminder/types";
import { fetcher } from "@website/fetcher/fetcher";

export const removeReminder = (body: UpdateReminderBody) =>
  fetcher({
    url: `${TOUR_REMINDER_URL}/remove`,
    method: "POST",
    data: body,
    headers: { product: "TOUR" }
  });
